import { TOUR_TRANSLATIONS } from "../translations"

export const getProductPageDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="pp-details-filters"]',
            title: t.ppDetailsFilters.title,
            content: t.ppDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="pp-details-table"]',
            title: t.ppDetailsTable.title,
            content: t.ppDetailsTable.content,
        },
        {
            target: '[data-tour="pp-details-create-report"]',
            title: t.ppDetailsCreateReport.title,
            content: t.ppDetailsCreateReport.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.ppDetailsModal.title,
            content: t.ppDetailsModal.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'pp-details-table', closeOnLeave: true },
        },
    ]
}
